import LineGraph from 'images/portfolio-tracker/line-graph';
import AssetClass from 'images/portfolio-tracker/asset-class';
import PieChart from 'images/portfolio-tracker/pie-chart';

export const uploadHoldingsCards = [
  {
    cardIdentifier: 'track-1',
    title: 'Upload your holdings',
    text: 'Sign up and add your holdings – either by connecting to your broker, uploading a spreadsheet, or manually entering your trading history or opening balance.',
  },
  {
    cardIdentifier: 'track-2',
    title: 'Get automatic updates',
    text: 'Sit back and watch as corporate action data (such as dividends and stock splits) are automatically incorporated – going back up to 20 years, and ongoing.',
  },
  {
    cardIdentifier: 'track-3',
    title: 'Gain powerful insights',
    text: 'Graph your performance, benchmark your portfolio against market indexes, see your asset allocation, and visualise your portfolio diversity by market, sector, country, and more.',
  },
];

export const swapYourSpreadsheetCards = [
  {
    cardIdentifier: 'track-1',
    title: 'Know your true performance',
    text: 'See the true performance of all your holdings – no matter where they live.',
    image: <LineGraph />,
  },
  {
    cardIdentifier: 'track-2',
    title: 'Track multiple asset classes',
    text: 'Track private equity, alternatives, real estate and more – all in a single place.',
    image: <AssetClass />,
  },
  {
    cardIdentifier: 'track-3',
    title: 'Make insight-driven decisions',
    text: 'Drive financial decisions knowing your end-of-day dynamic wealth position.',
    image: <PieChart />,
  },
];
